import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/siteData";

const HELP = [
  "Klart afgrænsede underentrepriser",
  "Ekstra kapacitet i travle perioder",
  "Bygge- og renoveringsopgaver",
  "Nedrivning og demontering",
  "Klargøring og oprydning af byggeplads",
  "Materialehåndtering",
  "Løbende eller projektbaseret samarbejde",
];

const STEPS = [
  "Kunden sender projektinformation",
  "Omfang og krav gennemgås",
  "Pris og tidsplan aftales",
  "Arbejdet udføres og dokumenteres",
  "Kunden modtager den aftalte dokumentation og faktura",
];

const Partnership = () => {
  useSEO({
    title: "Samarbejde | Fleksibel underentreprenør – AA+PLUS MILJØSANERING",
    description: "Et fleksibelt B2B-samarbejde for hovedentreprenører og byggevirksomheder. Ekstra kapacitet og klart afgrænsede underentrepriser.",
  });

  return (
    <div data-testid="partnership-page">
      <section className="relative py-20 lg:py-28">
        <div className="absolute inset-0">
          <img src={IMAGES.construction} alt="Byggeprojekt med stålkonstruktion" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gray-900/75" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">Samarbejde</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl">Et fleksibelt B2B-samarbejde</h1>
          <p className="mt-5 text-lg text-gray-200 max-w-2xl leading-relaxed">
            Vi er en selvstændig bygge- og entreprenørvirksomhed, der indgår som underentreprenør eller ekstern samarbejdspartner for hovedentreprenører og andre byggevirksomheder.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14">
          <Reveal>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900">Vi kan hjælpe med</h2>
            <ul className="mt-6 space-y-3">
              {HELP.map((h) => (
                <li key={h} className="flex items-start gap-3 text-gray-700 text-lg">
                  <Check size={20} className="text-[#FF5A00] mt-1 shrink-0" /> {h}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="bg-gray-50 border border-gray-200 rounded-sm p-8 lg:p-10">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900">Sådan starter et samarbejde</h2>
              <ol className="mt-6 space-y-5">
                {STEPS.map((s, i) => (
                  <li key={s} className="flex items-start gap-4">
                    <span className="shrink-0 w-9 h-9 bg-[#FF5A00] text-white font-display font-bold rounded-sm flex items-center justify-center">{i + 1}</span>
                    <span className="text-gray-700 pt-1.5">{s}</span>
                  </li>
                ))}
              </ol>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-16 bg-[#1F2937]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white">Skal vi tage en snak om et samarbejde?</h2>
          <p className="mt-4 text-gray-300 text-lg">Send os oplysninger om jeres projekt, så vender vi tilbage hurtigst muligt.</p>
          <Link to="/kontakt" data-testid="partnership-cta-btn" className="mt-8 inline-flex items-center gap-2 bg-[#FF5A00] text-white font-semibold px-7 py-4 rounded-sm hover:bg-[#E04F00] transition-colors">
            Kontakt os om et samarbejde <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Partnership;
